/* ============================================================
   MYNA — Cash on Delivery with partial advance
   Adds a "Payment Method" choice to the cart drawer's payment step.
   - Pay Online  -> untouched existing Razorpay full-prepaid flow (#ck-pay-btn)
   - COD         -> orders over THRESHOLD pay ADVANCE_PCT% now (Razorpay),
                    balance on delivery. Orders <= THRESHOLD are full COD.
   Backend: COD_BACKEND/api/cod  (actions: advance-order, complete, place-cod)
   ============================================================ */
(function () {
  'use strict';

  var COD_BACKEND = 'https://myna-login.vercel.app';
  var PREPAID_BACKEND = 'https://myna-backend.vercel.app';
  var THRESHOLD   = 1000;   // ₹ — orders above this need an advance for COD
  var ADVANCE_PCT = 20;     // % of total collected online for COD

  /* Pre-warm the serverless payment functions when the cart opens, so the
     "Pay" click doesn't wait for a cold start. Fire-and-forget, throttled. */
  var lastWarm = 0;
  function warmBackends() {
    var now = Date.now();
    if (now - lastWarm < 20000) return;
    lastWarm = now;
    try { fetch(COD_BACKEND + '/api/cod', { method: 'GET', cache: 'no-store' }).catch(function () {}); } catch (e) {}
    try { fetch(PREPAID_BACKEND + '/api/create-razorpay-order', { method: 'GET', cache: 'no-store' }).catch(function () {}); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-myna-cart],[data-cart-toggle],#cart-icon-bubble,.cart-icon-bubble,.header__icon--cart,.alk-cart-btn,.js-cart-trigger,a[href="/cart"]')) {
      warmBackends();
    }
  }, true);

  var $ = function (id) { return document.getElementById(id); };
  function inr(n) { return '₹' + Math.round(n).toLocaleString('en-IN'); }
  function digits(s) { return String(s || '').replace(/\D/g, ''); }

  var method = 'online';   // 'online' | 'cod'
  var injected = false;

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function calcTotals(c) {
    var sub = 0, qty = 0, units = [];
    (c.items || []).forEach(function (it) {
      var p = it.final_price / 100, q = it.quantity;
      sub += p * q; qty += q;
      for (var i = 0; i < q; i++) units.push(p);
    });
    units.sort(function (a, b) { return a - b; });
    var fc = Math.floor(qty / 3), disc = 0;
    for (var j = 0; j < fc; j++) disc += units[j];
    var del = 0; // free delivery (matches cart drawer FREESHIP=0)
    return { sub: sub, disc: disc, del: del, total: sub - disc + del, qty: qty };
  }
  function lineItems(c) {
    return (c.items || []).map(function (it) { return { variant_id: it.variant_id, quantity: it.quantity }; });
  }
  function gatherCustomer() {
    return {
      name:  ($('myna-fName')  || {}).value || '',
      phone: digits(($('myna-fPhone') || {}).value).slice(-10),
      email: ($('myna-fEmail') || {}).value || ''
    };
  }
  function gatherAddress() {
    return {
      flat:     ($('myna-fFlat')  || {}).value || '',
      area:     ($('myna-fArea')  || {}).value || '',
      landmark: ($('myna-fLand')  || {}).value || '',
      city:     ($('myna-fCity')  || {}).value || '',
      state:    ($('myna-fState') || {}).value || '',
      pincode:  digits(($('myna-fPin') || {}).value).slice(0, 6)
    };
  }
  function validAddress(cu, ad) {
    return cu.name.trim().length >= 2 && cu.phone.length === 10 &&
           ad.pincode.length === 6 && ad.flat.trim().length >= 3 && ad.area.trim().length >= 3;
  }

  function injectStyles() {
    if ($('myna-cod-styles')) return;
    var s = document.createElement('style');
    s.id = 'myna-cod-styles';
    s.textContent =
      '.myna-pm{margin:0 0 4px}' +
      '.myna-pm-opt{display:flex;align-items:flex-start;gap:12px;padding:14px 15px;border:1px solid rgba(245,241,234,.14);border-radius:14px;margin-bottom:10px;cursor:pointer;transition:border-color .2s,background .2s;background:rgba(255,255,255,.02)}' +
      '.myna-pm-opt.sel{border-color:#c9a96e;background:rgba(201,169,110,.08)}' +
      '.myna-pm-radio{flex-shrink:0;width:18px;height:18px;border-radius:50%;border:1.5px solid rgba(245,241,234,.4);margin-top:2px;position:relative;transition:.2s}' +
      '.myna-pm-opt.sel .myna-pm-radio{border-color:#c9a96e}' +
      '.myna-pm-opt.sel .myna-pm-radio::after{content:"";position:absolute;inset:3px;border-radius:50%;background:#c9a96e}' +
      '.myna-pm-txt{flex:1}' +
      '.myna-pm-t{font-size:14px;color:#f5f1ea;font-weight:500;display:flex;align-items:center;gap:8px}' +
      '.myna-pm-t .tag{font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:#c9a96e;border:1px solid rgba(201,169,110,.4);border-radius:20px;padding:2px 7px}' +
      '.myna-pm-s{font-size:12px;color:rgba(245,241,234,.55);margin-top:3px;line-height:1.4}' +
      '.myna-cod-break{border:1px dashed rgba(201,169,110,.35);border-radius:12px;padding:12px 14px;margin:2px 0 4px;background:rgba(201,169,110,.05)}' +
      '.myna-cod-break .r{display:flex;justify-content:space-between;font-size:13px;color:rgba(245,241,234,.8);padding:4px 0}' +
      '.myna-cod-break .r.now{color:#f5f1ea;font-weight:600}' +
      '.myna-cod-break .r .v{font-feature-settings:"lnum" 1}' +
      '.myna-cod-err{color:#e8a87c;font-size:.82rem;margin:8px 0 0;text-align:center}';
    document.head.appendChild(s);
  }

  function inject() {
    var slide = $('myna-slide3');
    if (!slide || injected) return;
    var body = slide.querySelector('.myna-sbody');
    var foot = slide.querySelector('.myna-sfoot');
    if (!body || !foot) return;
    injected = true;
    injectStyles();

    // Payment method chooser at top of the payment body
    var pm = document.createElement('div');
    pm.className = 'myna-pm';
    pm.innerHTML =
      '<div class="myna-card-eye" style="margin-bottom:10px"><span class="e">Payment Method</span></div>' +
      '<div class="myna-pm-opt sel" data-pm="online"><span class="myna-pm-radio"></span><span class="myna-pm-txt">' +
        '<span class="myna-pm-t">Pay Online <span class="tag">Secure</span></span>' +
        '<span class="myna-pm-s">UPI, Cards, Netbanking &amp; Wallets via Razorpay.</span></span></div>' +
      '<div class="myna-pm-opt" data-pm="cod"><span class="myna-pm-radio"></span><span class="myna-pm-txt">' +
        '<span class="myna-pm-t">Cash on Delivery</span>' +
        '<span class="myna-pm-s" id="myna-cod-sub">Pay on delivery.</span></span></div>' +
      '<div class="myna-cod-break" id="myna-cod-break" style="display:none">' +
        '<div class="r now"><span>Pay now (' + ADVANCE_PCT + '% advance)</span><span class="v" id="myna-cod-now">₹0</span></div>' +
        '<div class="r"><span>Pay on delivery</span><span class="v" id="myna-cod-later">₹0</span></div>' +
      '</div>';
    body.insertBefore(pm, body.firstChild);

    // COD action button in the footer (hidden until COD chosen)
    var codBtn = document.createElement('button');
    codBtn.className = 'myna-btn myna-btn--primary myna-btn--block';
    codBtn.id = 'myna-cod-btn';
    codBtn.style.display = 'none';
    codBtn.innerHTML = '<span class="lbl">Place Order</span><span class="myna-amt" id="myna-cod-amt">₹0</span><span class="myna-spin"><i></i></span>';
    foot.appendChild(codBtn);

    pm.addEventListener('click', function (e) {
      var opt = e.target.closest('.myna-pm-opt'); if (!opt) return;
      setMethod(opt.dataset.pm);
    });
    codBtn.addEventListener('click', onCodClick);

    refreshUI();
  }

  function setMethod(m) {
    method = m;
    var opts = document.querySelectorAll('.myna-pm-opt');
    [].forEach.call(opts, function (o) { o.classList.toggle('sel', o.dataset.pm === m); });
    refreshUI();
  }

  function refreshUI() {
    fetchCart().then(function (c) {
      var t = calcTotals(c);
      var needsAdvance = t.total > THRESHOLD;
      var advance = needsAdvance ? Math.round(t.total * ADVANCE_PCT / 100) : 0;
      var later = t.total - advance;

      var payBtn = $('ck-pay-btn');
      var codBtn = $('myna-cod-btn');
      var brk = $('myna-cod-break');
      var sub = $('myna-cod-sub');

      if (sub) sub.textContent = needsAdvance
        ? ('Pay ' + inr(advance) + ' now (' + ADVANCE_PCT + '%), ' + inr(later) + ' on delivery.')
        : 'Pay the full amount on delivery.';

      if (method === 'cod') {
        if (payBtn) payBtn.style.display = 'none';
        if (codBtn) {
          codBtn.style.display = '';
          var lbl = codBtn.querySelector('.lbl');
          var amt = $('myna-cod-amt');
          if (needsAdvance) { if (lbl) lbl.textContent = 'Pay Advance & Place Order'; if (amt) amt.textContent = inr(advance); }
          else { if (lbl) lbl.textContent = 'Place Order (COD)'; if (amt) amt.textContent = inr(t.total); }
        }
        if (brk) brk.style.display = needsAdvance ? '' : 'none';
        if (needsAdvance) {
          var n = $('myna-cod-now'), l = $('myna-cod-later');
          if (n) n.textContent = inr(advance);
          if (l) l.textContent = inr(later);
        }
      } else {
        if (payBtn) payBtn.style.display = '';
        if (codBtn) codBtn.style.display = 'none';
        if (brk) brk.style.display = 'none';
      }
    }).catch(function () {});
  }

  function codErr(msg) {
    var foot = $('myna-slide3') && $('myna-slide3').querySelector('.myna-sfoot');
    if (!foot) return;
    var old = foot.querySelector('.myna-cod-err'); if (old) old.remove();
    var p = document.createElement('p'); p.className = 'myna-cod-err'; p.textContent = msg;
    foot.appendChild(p); setTimeout(function () { if (p.parentNode) p.remove(); }, 6000);
  }

  function busy(on) {
    var b = $('myna-cod-btn'); if (b) b.classList.toggle('is-loading', !!on);
  }

  function showSuccess(orderName) {
    fetch('/cart/clear.js', { method: 'POST' }).catch(function () {});
    var s = $('myna-success'); if (s) s.classList.add('show');
    var o = $('myna-orderId'); if (o) o.textContent = orderName || 'Order placed';
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count,#cart-count,.myna-cart-count,.alk-cart-count'), function (el) {
      el.textContent = '0'; el.style.display = 'none';
    });
    busy(false);
  }

  function api(payload) {
    return fetch(COD_BACKEND + '/api/cod', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  function onCodClick() {
    var btn = $('myna-cod-btn');
    if (btn && btn.classList.contains('is-loading')) return;
    var cu = gatherCustomer(), ad = gatherAddress();
    if (!validAddress(cu, ad)) { codErr('Please complete your name, phone and address first.'); return; }
    busy(true);
    fetchCart().then(function (c) {
      var t = calcTotals(c);
      if (!t.qty) { busy(false); codErr('Your bag is empty.'); return; }
      var li = lineItems(c);
      var needsAdvance = t.total > THRESHOLD;

      if (!needsAdvance) {
        // full COD, no online payment
        api({ action: 'place-cod', customer: cu, address: ad, line_items: li, totals: t }).then(function (res) {
          if (res && res.ok) showSuccess(res.order_name);
          else { busy(false); codErr((res && res.error) || 'Could not place the order.'); }
        }).catch(function () { busy(false); codErr('Network error. Please try again.'); });
        return;
      }

      // advance COD -> create Razorpay order for the advance
      var advance = Math.round(t.total * ADVANCE_PCT / 100);
      api({ action: 'advance-order', amountPaise: advance * 100 }).then(function (o) {
        if (!o || !o.ok || !o.id) { busy(false); codErr('Unable to start the advance payment. Please try again.'); return; }
        openRazorpay(o, advance, cu, ad, li, t);
      }).catch(function () { busy(false); codErr('Network error. Please try again.'); });
    }).catch(function () { busy(false); codErr('Could not read your bag. Please try again.'); });
  }

  function openRazorpay(order, advance, cu, ad, li, totals) {
    var opts = {
      key: order.keyId,
      amount: order.amount,
      currency: 'INR',
      order_id: order.id,
      name: 'MYNA by Alankar Jewellers',
      description: 'COD advance (' + ADVANCE_PCT + '%) — balance on delivery',
      prefill: { name: cu.name, email: cu.email, contact: cu.phone ? '+91' + cu.phone : '' },
      theme: { color: '#c9a96e', backdrop_color: 'rgba(10,10,10,.88)' },
      redirect: false,
      handler: function (resp) {
        busy(true);
        api({
          action: 'complete',
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_signature: resp.razorpay_signature,
          customer: cu, address: ad, line_items: li, totals: totals,
          advancePaise: advance * 100
        }).then(function (res) {
          if (res && res.ok) showSuccess(res.order_name);
          else { busy(false); codErr((res && res.error) || 'Payment done but order failed. We will contact you.'); }
        }).catch(function () { busy(false); codErr('Payment done but order failed. We will contact you.'); });
      },
      modal: { ondismiss: function () { busy(false); } }
    };
    function open() { var rzp = new Razorpay(opts); rzp.on('payment.failed', function () { busy(false); codErr('Payment failed. Please try again.'); }); rzp.open(); }
    if (window.Razorpay) { open(); return; }
    var sc = document.createElement('script');
    sc.src = 'https://checkout.razorpay.com/v1/checkout.js';
    sc.onload = open;
    sc.onerror = function () { busy(false); codErr('Payment gateway unavailable. Please refresh.'); };
    document.head.appendChild(sc);
  }

  // Inject when the drawer/payment step is available; retry a few times as it loads.
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    if ($('myna-slide3')) { inject(); clearInterval(iv); }
    else if (tries > 40) clearInterval(iv);
  }, 250);
  if (document.readyState !== 'loading') { if ($('myna-slide3')) inject(); }
  document.addEventListener('DOMContentLoaded', function () { if ($('myna-slide3')) inject(); });

  // Recompute amounts each time the user reaches the payment step (click a "continue to payment").
  document.addEventListener('click', function (e) {
    if (e.target.closest('#myna-toStep3') || e.target.closest('[data-goto="2"]')) {
      setTimeout(refreshUI, 60);
    }
  });
})();

/* ------------------------------------------------------------
   Mobile-safe background scroll lock for the checkout drawer.
   The drawer's own overflow:hidden doesn't hold on iOS, so the page
   behind still scrolls. We pin <body> with position:fixed while the
   drawer is open and restore the exact scroll position on close.
   ------------------------------------------------------------ */
(function () {
  'use strict';
  var locked = false, savedY = 0;
  function lock() {
    if (locked) return;
    savedY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = (-savedY) + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    locked = true;
  }
  function unlock() {
    if (!locked) return;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.style.overflow = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, savedY);
    locked = false;
  }
  function watch() {
    var d = document.getElementById('myna-drawer');
    if (!d) return false;
    var obs = new MutationObserver(function () {
      if (d.classList.contains('open')) lock(); else unlock();
    });
    obs.observe(d, { attributes: true, attributeFilter: ['class'] });
    if (d.classList.contains('open')) lock();
    return true;
  }
  var t = 0, iv = setInterval(function () { t++; if (watch() || t > 40) clearInterval(iv); }, 250);
  if (document.readyState !== 'loading') watch();
  document.addEventListener('DOMContentLoaded', watch);
})();

/* ------------------------------------------------------------
   PDP add-to-cart: some product templates submit the add-to-cart
   form natively (full page reload -> /cart -> drawer). Intercept
   that submit and add via AJAX so the cart drawer opens instantly
   with no reload. Falls back to a native submit if the AJAX fails.
   ------------------------------------------------------------ */
(function () {
  'use strict';
  // Shared AJAX add. goCheckout=true => "Buy It Now" (open drawer + jump to checkout step).
  function ajaxAdd(form, goCheckout, btn) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-loading'); }
    var addUrl = (window.routes && window.routes.cart_add_url) ? (window.routes.cart_add_url + '.js') : '/cart/add.js';
    var fd = new FormData(form);
    // The cart drawer's fetch() hook detects /cart/add and opens + renders the drawer.
    return fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json().catch(function () { return {}; }); })
      .then(function () {
        if (window.mynaOpenCart) window.mynaOpenCart();
        if (goCheckout) { setTimeout(function () { var s = document.getElementById('myna-toStep2'); if (s) s.click(); }, 420); }
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); } });
  }

  // Add to Cart — native form submit.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ajaxAdd(form, false, form.querySelector('button[type="submit"], [type="submit"]'));
  }, true);

  // Buy It Now — custom type="button" button; intercept its click before the theme's handler runs.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-buy-btn, [data-buy-now], .alk-buy-now, .pdp-buynow, .myna-buy-now');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ajaxAdd(form, false, btn);
  }, true);
})();
